// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-collapse {
  margin: auto;
  width: 85%;
}
.container-collapse .ant-collapse-expand-icon {
  margin-top: 0.3%;
}
.container-legaltxt {
  text-align: center;
  align-items: center;
  justify-content: center;
  font: normal normal 700 11px Poppins;
  color: rgba(89, 88, 90, 0.88);
  margin-top: 1%;
}
`, "",{"version":3,"sources":["webpack://./src/components/PopBallon/CollapsePopBallon/collapsePopBallon.less"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,UAAA;AACJ;AAHA;EAKQ,gBAAA;AACR;AAIA;EACI,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,6BAAA;EACA,cAAA;AAFJ","sourcesContent":[".container-collapse{\n    margin: auto;\n    width: 85%;\n\n    .ant-collapse-expand-icon{\n        margin-top: 0.3%;\n    }\n\n}\n\n.container-legaltxt {\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n    font: normal normal 700 11px Poppins;\n    color: rgba(89, 88, 90, 0.88);\n    margin-top: 1%;\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
